@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
}

.root {
  display: inline-block;
  animation: rotate 1.4s linear infinite;
  color: var(--tuna-palette-primary-main);
}

.circle {
  stroke: currentColor;
  stroke-linecap: round;
  animation: dash 1.4s ease-in-out infinite;
}

.colorSecondary {
  color: var(--tuna-palette-secondary-main);
}

.determinate {
  animation: none;
}

.determinate .circle {
  animation: none;
  transition: stroke-dashoffset 0.3s ease;
}

.colorError {
  color: var(--tuna-palette-error-main);
}

.colorInherit {
  color: inherit;
}

@media (prefers-reduced-motion: reduce) {
  .root {
    animation-duration: 0s !important;
  }
}
